import React from 'react';
import { object, string, bool } from 'prop-types';
import OldCookieBanner from './OldCookieBanner';
import NewCookieBanner from './NewCookieBanner';

const CookieBanner = ({ settings, token, isEmbedded }) => {
  const { ACTIVATE_COOKIES_BANNER_2021 } = settings;
  return ACTIVATE_COOKIES_BANNER_2021 ? (
    <NewCookieBanner settings={settings} token={token} isEmbedded={isEmbedded} />
  ) : (
    <OldCookieBanner settings={settings} token={token} isEmbedded={isEmbedded} />
  );
};

CookieBanner.propTypes = {
  settings: object,
  token: string,
  isEmbedded: bool,
};

export default CookieBanner;
